import deep from 'deep-get-set';
import Immutable from 'immutable';
import { push } from 'react-router-redux';
import { createSelector } from 'reselect';
import { ORGANIZATION_ID } from '@src/constants/local-storage-ids';

const LOAD_OWNED = 'organization/LOAD_OWNED';
const LOAD_OWNED_SUCCESS = 'organization/LOAD_OWNED_SUCCESS';
const LOAD_OWNED_FAIL = 'organization/LOAD_OWNED_FAIL';
const LOAD_ORGANIZATION_MEMBERS = 'organization/LOAD_ORGANIZATION_MEMBERS';
const LOAD_ORGANIZATION_MEMBERS_SUCCESS = 'organization/LOAD_ORGANIZATION_MEMBERS_SUCCESS';
const LOAD_ORGANIZATION_MEMBERS_FAIL = 'organization/LOAD_ORGANIZATION_MEMBERS_FAIL';
const LOAD_MEMBER = 'organization/LOAD_MEMBER';
const LOAD_MEMBER_SUCCESS = 'organization/LOAD_MEMBER_SUCCESS';
const LOAD_MEMBER_FAIL = 'organization/LOAD_MEMBER_FAIL';
const LOAD_SELECT = 'organization/LOAD_SELECT';
export const LOAD_SELECT_SUCCESS = 'organization/LOAD_SELECT_SUCCESS';
const LOAD_SELECT_FAIL = 'organization/LOAD_SELECT_FAIL';
const LOAD_CREATE = 'organization/LOAD_CREATE';
const LOAD_CREATE_SUCCESS = 'organization/LOAD_CREATE_SUCCESS';
const LOAD_CREATE_FAIL = 'organization/LOAD_CREATE_FAIL';
const LOAD_UPDATE = 'organization/LOAD_UPDATE';
const LOAD_UPDATE_SUCCESS = 'organization/LOAD_UPDATE_SUCCESS';
const LOAD_UPDATE_FAIL = 'organization/LOAD_UPDATE_FAIL';
const LOAD_INVITE_MEMBERS = 'organization/LOAD_INVITE_MEMBERS';
const LOAD_INVITE_MEMBERS_SUCCESS = 'organization/LOAD_INVITE_MEMBERS_SUCCESS';
const LOAD_INVITE_MEMBERS_FAIL = 'organization/LOAD_INVITE_MEMBERS_FAIL';
const LOAD_ROLES = 'organization/LOAD_ROLES';
const LOAD_ROLES_SUCCESS = 'organization/LOAD_ROLES_SUCCESS';
const LOAD_ROLES_FAIL = 'organization/LOAD_ROLES_FAIL';
const LOAD_DELETE_MEMBERS = 'organization/LOAD_DELETE_MEMBERS';
const LOAD_DELETE_MEMBERS_SUCCESS = 'organization/LOAD_DELETE_MEMBERS_SUCCESS';
const LOAD_DELETE_MEMBERS_FAIL = 'organization/LOAD_DELETE_MEMBERS_FAIL';
const LOAD_UPDATE_MEMBER = 'organization/LOAD_UPDATE_MEMBER';
const LOAD_UPDATE_MEMBER_SUCCESS = 'organization/LOAD_UPDATE_MEMBER_SUCCESS';
const LOAD_UPDATE_MEMBER_FAIL = 'organization/LOAD_UPDATE_MEMBER_FAIL';
const ORGANIZATION_FROM_LOCALSTORAGE_SET = 'ORGANIZATION_FROM_LOCALSTORAGE_SET';
const LOAD_CAN_MANAGE_MEMBERS = 'organization/LOAD_CAN_MANAGE_MEMBERS';
const LOAD_CAN_MANAGE_MEMBERS_SUCCESS = 'organization/LOAD_CAN_MANAGE_MEMBERS_SUCCESS';
const LOAD_CAN_MANAGE_MEMBERS_FAIL = 'organization/LOAD_CAN_MANAGE_MEMBERS_FAIL';

const previousOrganizationId = localStorage.getItem(ORGANIZATION_ID);

const initialState = Immutable.fromJS({
  hasInitiallyLoaded: false,
  loading: false,
  errorMessage: null,
  ownedOrganization: {},
  ownedOrganizationMembers: [],
  selectedOrganizationId: previousOrganizationId || null,
  selectedOrganization: null,
  memberOrganizations: [],
  organizationRoles: [],
  loadingInvites: [],
  loadingDeletes: [],
  loadingMember: null,
  isContextChanging: false,
  canManageMembers: false,
  isOwnerOfSelectedOrg: false,
  loadingCanManageMembers: false
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_OWNED:
      return state.set('loading', true);

    case LOAD_OWNED_FAIL:
      return state.set('loading', false).set('errorMessage', action.payload);

    case LOAD_OWNED_SUCCESS:
      return state
        .set('loading', false)
        .set('errorMessage', false)
        .set('ownedOrganization', action.payload);

    case LOAD_ORGANIZATION_MEMBERS:
      return state.set('loading', true);

    case LOAD_ORGANIZATION_MEMBERS_FAIL:
      return state.set('loading', false).set('errorMessage', action.payload);

    case LOAD_ORGANIZATION_MEMBERS_SUCCESS:
      return state
        .set('loading', false)
        .set('errorMessage', false)
        .set('ownedOrganizationMembers', action.payload);

    case LOAD_MEMBER:
      return state.set('loading', true);

    case LOAD_MEMBER_FAIL:
      return state
        .set('loading', false)
        .set('hasInitiallyLoaded', true)
        .set('errorMessage', action.payload);

    case LOAD_MEMBER_SUCCESS:
      return state
        .set('loading', false)
        .set('hasInitiallyLoaded', true)
        .set('errorMessage', false)
        .set('memberOrganizations', action.payload);

    case LOAD_SELECT:
      return state.set('loading', true).set('contextChange', true);

    case LOAD_SELECT_FAIL:
      return state.set('loading', false).set('errorMessage', action.payload);

    case LOAD_SELECT_SUCCESS:
      return state
        .set('loading', false)
        .set('contextChange', false)
        .set('errorMessage', false)
        .set('selectedOrganization', action.payload)
        .set('selectedOrganizationId', action.payload ? action.payload.id : null);

    case LOAD_CREATE:
      return state.set('loading', true);

    case LOAD_CREATE_FAIL:
      return state.set('loading', false).set('errorMessage', action.payload);

    case LOAD_CREATE_SUCCESS:
      return state
        .set('loading', false)
        .set('errorMessage', false)
        .set('ownedOrganization', action.payload);

    case LOAD_UPDATE:
      return state.set('loading', true);

    case LOAD_UPDATE_FAIL:
      return state.set('loading', false).set('errorMessage', action.payload);

    case LOAD_UPDATE_SUCCESS:
      return state
        .set('loading', false)
        .set('errorMessage', false)
        .set('ownedOrganization', action.payload);

    case LOAD_INVITE_MEMBERS:
      return state.set('loading', true).set('loadingInvites', action.payload);

    case LOAD_INVITE_MEMBERS_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.payload)
        .set('loadingInvites', []);

    case LOAD_INVITE_MEMBERS_SUCCESS:
      return state.set('loading', false).set('errorMessage', false).set('loadingInvites', []);

    case LOAD_ROLES:
      return state.set('loading', true);

    case LOAD_ROLES_FAIL:
      return state.set('loading', false).set('errorMessage', action.payload);

    case LOAD_ROLES_SUCCESS:
      return state
        .set('loading', false)
        .set('errorMessage', false)
        .set('organizationRoles', action.payload);

    case LOAD_DELETE_MEMBERS:
      return state.set('loading', true).set('loadingDeletes', action.payload);

    case LOAD_DELETE_MEMBERS_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.payload)
        .set('loadingDeletes', []);

    case LOAD_DELETE_MEMBERS_SUCCESS:
      return state.set('loading', false).set('errorMessage', false).set('loadingDeletes', []);

    case LOAD_UPDATE_MEMBER:
      return state.set('loading', true).set('loadingMember', action.payload);

    case LOAD_UPDATE_MEMBER_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.payload)
        .set('loadingMember', null);

    case LOAD_UPDATE_MEMBER_SUCCESS:
      return state.set('loading', false).set('errorMessage', false).set('loadingMember', null);

    case ORGANIZATION_FROM_LOCALSTORAGE_SET:
      return state.set('selectedOrganization', action.selectedOrganization);

    case LOAD_CAN_MANAGE_MEMBERS:
      return state.set('loadingCanManageMembers', true);

    case LOAD_CAN_MANAGE_MEMBERS_SUCCESS:
      return state
        .set('loadingCanManageMembers', false)
        .set('canManageMembers', action.payload.canManageMembers)
        .set('isOwnerOfSelectedOrg', action.payload.isOwner);

    case LOAD_CAN_MANAGE_MEMBERS_FAIL:
      return state
        .set('loadingCanManageMembers', false)
        .set('canManageMembers', false)
        .set('isOwnerOfSelectedOrg', false);

    default:
      return state;
  }
}

// Actions
const getOrganizationById = (id, getState) => {
  const memberOrganizations = getState().get('organization').get('memberOrganizations');

  return id && memberOrganizations.find(({ organization }) => organization.id === id);
};

export const setOrganizationFromLocalStorage = (id) => (dispatch, getState) => {
  const selectedOrganization = getOrganizationById(id, getState);

  dispatch({
    type: ORGANIZATION_FROM_LOCALSTORAGE_SET,
    selectedOrganization
  });
};

const getFirstAvailableOrganizationId = (getState) => {
  const memberOrganizations = getState().get('organization').get('memberOrganizations');

  const availableOrganizations = memberOrganizations.filter(
    ({ organization }) => !organization.expired
  );

  return availableOrganizations.length ? availableOrganizations[0].organization.id : null;
};

/**
 * Selects context depending on previously selected context and db data
 */
export const selectDefaultContext = () => async (dispatch, getState) => {
  const user = getState().get('auth').get('user');

  let lastSelectedOrganizationId = user.selectedOrganizationId;

  const selectedOrganization = getOrganizationById(lastSelectedOrganizationId, getState);

  if (
    !selectedOrganization ||
    selectedOrganization === null ||
    selectedOrganization.organization.expired
  ) {
    lastSelectedOrganizationId = null;

    if (user.expiredTrial) {
      lastSelectedOrganizationId = getFirstAvailableOrganizationId(getState);
      if (!lastSelectedOrganizationId) {
        dispatch(push('/billing'));
      }
    }
  }
};

/**
 * Fetch all organization the user is owner
 */
export const getOwnedOrganization = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_OWNED });

  try {
    const response = await api.get(`/organizations/owner`);
    if (response.message) {
      dispatch({ type: LOAD_OWNED_FAIL, payload: response.message });
      return;
    }

    const organization = response.rows[0] || {};

    dispatch({ type: LOAD_OWNED_SUCCESS, payload: organization });
  } catch (error) {
    dispatch({ type: LOAD_OWNED_FAIL, payload: error });
  }
};

/**
 * Fetch all organizations the user is member
 */
export const getMemberOrganizations = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_MEMBER });

  try {
    const response = await api.get(`/organizations`);
    if (response.message) {
      dispatch({ type: LOAD_MEMBER_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_MEMBER_SUCCESS, payload: response.rows });
  } catch (error) {
    dispatch({ type: LOAD_MEMBER_FAIL, payload: error });
  }
};

/**
 * Select a organization that the user is member
 * @param {string} organizationId - Selected organization ID.
 * If is set to null will "unselect" the organization
 * @param {bool} forceUpdate - Call with this flag to update the database
 * and reload the user from the API. This is used whenever a new org is
 * selected from the Header dropdown.
 */
export const selectOrganization =
  (organizationId, forceUpdate) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_SELECT });

    const selectedOrganization = getOrganizationById(organizationId, getState);

    if (selectedOrganization === undefined) {
      dispatch({ type: LOAD_SELECT_FAIL, payload: 'Organization not found' });
      return;
    }

    if (selectedOrganization && selectedOrganization.expired) {
      dispatch({ type: LOAD_SELECT_FAIL, payload: "Organization owner's free trial expired" });
      return;
    }

    if (forceUpdate) {
      const response = await api.patch('/organizations/select', { data: { organizationId } });
      if (response && response.message) {
        dispatch({ type: LOAD_SELECT_FAIL, payload: response.message });
        return;
      }
    }

    localStorage.setItem(ORGANIZATION_ID, organizationId);

    dispatch({ type: LOAD_SELECT_SUCCESS, payload: selectedOrganization });
  };

/**
 * Create a new organization
 * @param {{ name: string }} organizationData
 * name: Organization name
 */
export const createOrganization =
  ({ name }) =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_CREATE });

    try {
      const response = await api.post(`/organizations`, {
        data: { name }
      });

      if (response.message) {
        dispatch({ type: LOAD_CREATE_FAIL, payload: response.message });
        return;
      }

      dispatch({ type: LOAD_CREATE_SUCCESS, payload: response });
    } catch (error) {
      dispatch({ type: LOAD_CREATE_FAIL, payload: error });
    }
  };

/**
 * Update a existing organization
 * @param {object} organizationData
 * name: Organization name
 */
export const updateOrganization =
  ({ name }) =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_UPDATE });

    const ownedOrganization = getState().get('organization').get('ownedOrganization');

    try {
      const response = await api.put(`/organizations/${ownedOrganization.id}`, {
        data: { name }
      });

      if (response.message) {
        dispatch({ type: LOAD_UPDATE_FAIL, payload: response.message });
        return;
      }

      dispatch({ type: LOAD_UPDATE_SUCCESS, payload: response });
    } catch (error) {
      dispatch({ type: LOAD_UPDATE_FAIL, payload: error });
    }
  };

/**
 * Invite new members to the organization
 * @param {array} members
 * List of users to be invited
 * [
 *  {
 *    email: string,
 *    roleId: uuid,
 *    all_campaigns_access: boolean,
 *    selected_campaigns?: [
 *      {
 *        id: number,
 *        roleId?: uuid
 *      }
 *    ]
 *  }
 * ]
 */
export const inviteMembers =
  (members = []) =>
  async (dispatch, getState, api) => {
    const loadingInvites = members.map(({ email }) => email);

    dispatch({ type: LOAD_INVITE_MEMBERS, payload: loadingInvites });

    const ownedOrganization = getState().get('organization').get('ownedOrganization');

    try {
      const response = await api.post(`/organizations/${ownedOrganization.id}/members`, {
        data: { members }
      });

      if (response && response.message) {
        dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: response.message });
        return;
      }

      dispatch({ type: LOAD_INVITE_MEMBERS_SUCCESS });
      dispatch(listMembers());
    } catch (error) {
      dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: error });
    }
  };

/**
 * Get organization member list
 */
export const listMembers = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_ORGANIZATION_MEMBERS });

  const ownedOrganization = getState().get('organization').get('ownedOrganization');

  try {
    const response = await api.get(`/organizations/${ownedOrganization.id}/members`);

    if (response.message) {
      dispatch({
        type: LOAD_ORGANIZATION_MEMBERS_FAIL,
        payload: response.message
      });
      return;
    }

    dispatch({
      type: LOAD_ORGANIZATION_MEMBERS_SUCCESS,
      payload: response.rows
    });
  } catch (error) {
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Update a member from the organization
 * @param {string} memberId
 * @param {object} toUpdate
 * {
 *   roleId?: uuid,
 *   all_campaigns_access?: boolean,
 *   selected_campaigns?: [
 *     {
 *       id: number,
 *       roleId?: uuid
 *     }
 *   ]
 * }
 */
export const updateMember = (memberId, toUpdate) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_UPDATE_MEMBER, payload: memberId });

  const ownedOrganization = getState().get('organization').get('ownedOrganization');

  const members = getState().get('organization').get('ownedOrganizationMembers');

  try {
    const response = await api.put(`/organizations/${ownedOrganization.id}/members/${memberId}`, {
      data: toUpdate
    });

    if (response.message) {
      dispatch({
        type: LOAD_UPDATE_MEMBER_FAIL,
        payload: response.message
      });
      return;
    }

    const updatedMember = response.rows[0];

    const updatedMemberList = members.map((member) =>
      member.id === memberId ? updatedMember : member
    );

    dispatch({ type: LOAD_UPDATE_MEMBER_SUCCESS });
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_SUCCESS, payload: updatedMemberList });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_MEMBER_FAIL, payload: error });
  }
};

/**
 * Delete a member from the organization
 * @param {string} memberId
 */
export const deleteMember = (memberId) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_ORGANIZATION_MEMBERS });

  const ownedOrganization = getState().get('organization').get('ownedOrganization');

  try {
    const response = await api.del(`/organizations/${ownedOrganization.id}/members/${memberId}`);

    if (response && response.message) {
      dispatch({
        type: LOAD_ORGANIZATION_MEMBERS_FAIL,
        payload: response.message
      });
      return;
    }

    dispatch(listMembers());
  } catch (error) {
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Delete a list of members from the organization
 * @param {string} memberId
 */
export const deleteMembers = (memberlist) => async (dispatch, getState, api) => {
  const idList = memberlist.map(({ id }) => ({ memberId: id }));

  dispatch({ type: LOAD_DELETE_MEMBERS, payload: idList });

  const ownedOrganization = getState().get('organization').get('ownedOrganization');

  try {
    const responses = await Promise.all(
      idList.map(({ memberId }) =>
        api.del(`/organizations/${ownedOrganization.id}/members/${memberId}`)
      )
    );

    const getMessage = (response) => response && response.message;
    if (responses.some(getMessage)) {
      const messages = responses.map(getMessage).filter((message) => !!message);

      dispatch({
        type: LOAD_DELETE_MEMBERS_FAIL,
        payload: messages
      });
      return;
    }

    dispatch({ type: LOAD_DELETE_MEMBERS_SUCCESS });
    dispatch(listMembers());
  } catch (error) {
    dispatch({ type: LOAD_DELETE_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Get organizations roles
 * @param {string} memberId
 */
export const getOrganizationRoles = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_ROLES });

  try {
    const response = await api.get('/organizations/roles');

    if (response.message) {
      dispatch({ type: LOAD_ROLES_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_ROLES_SUCCESS, payload: response.rows });
  } catch (error) {
    dispatch({ type: LOAD_ROLES_FAIL, payload: error });
  }
};

/**
 * Get org info with invite token
 * @param {string} inviteToken
 */
export const getOrganizationInfoWithInviteToken =
  ({ inviteToken, pending = false }) =>
  async (dispatch, getState, api) => {
    try {
      const response = await api.get(
        `/organizations?invite_token=${inviteToken}&pending=${pending}`
      );

      if (response.message) {
        return null;
      }

      return response;
    } catch (error) {
      return null;
    }
  };

/**
 * Get org info with invite token
 * @param {string} inviteToken
 */
export const acceptOrganizationInvite = (inviteToken) => async (dispatch, getState, api) => {
  try {
    await api.post(`/organizations/accept-invite`, { data: { inviteToken } });

    return;
  } catch (error) {
    return null;
  }
};

/**
 * Check if user can manage members of the selected organization.
 * @returns {Promise<{canManageMembers: boolean, isOwner: boolean}>}
 */
export const checkCanManageMembers = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_CAN_MANAGE_MEMBERS });

  try {
    const selectedOrganization = getState().get('organization').get('selectedOrganization');

    if (!selectedOrganization || !selectedOrganization.organization?.id) {
      dispatch({ type: LOAD_CAN_MANAGE_MEMBERS_FAIL });
      return { canManageMembers: false, isOwner: false };
    }

    const organizationId = selectedOrganization.organization.id;
    const response = await api.get(`/organizations/${organizationId}/can-manage-members`);

    if (response.message) {
      dispatch({ type: LOAD_CAN_MANAGE_MEMBERS_FAIL });
      return { canManageMembers: false, isOwner: false };
    }

    const result = {
      canManageMembers: response.canManageMembers === true,
      isOwner: response.isOwner === true
    };

    dispatch({ type: LOAD_CAN_MANAGE_MEMBERS_SUCCESS, payload: result });
    return result;
  } catch (error) {
    dispatch({ type: LOAD_CAN_MANAGE_MEMBERS_FAIL });
    return { canManageMembers: false, isOwner: false };
  }
};

/**
 * List members of the selected organization.
 * Used when admin has can_manage_members permission.
 */
export const listMembersOfSelectedOrg = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_ORGANIZATION_MEMBERS });

  const selectedOrganization = getState().get('organization').get('selectedOrganization');

  if (!selectedOrganization || !selectedOrganization.organization?.id) {
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: 'No organization selected' });
    return;
  }

  const organizationId = selectedOrganization.organization.id;

  try {
    const response = await api.get(`/organizations/${organizationId}/members`);

    if (response.message) {
      dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: response.message });
      return;
    }

    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_SUCCESS, payload: response.rows });
  } catch (error) {
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_FAIL, payload: error });
  }
};

/**
 * Invite members to the selected organization.
 */
export const inviteMembersToSelectedOrg =
  (members = []) =>
  async (dispatch, getState, api) => {
    const loadingInvites = members.map(({ email }) => email);

    dispatch({ type: LOAD_INVITE_MEMBERS, payload: loadingInvites });

    const selectedOrganization = getState().get('organization').get('selectedOrganization');

    if (!selectedOrganization || !selectedOrganization.organization?.id) {
      dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: 'No organization selected' });
      return;
    }

    const organizationId = selectedOrganization.organization.id;

    try {
      const response = await api.post(`/organizations/${organizationId}/members`, {
        data: { members }
      });

      if (response && response.message) {
        dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: response.message });
        return;
      }

      dispatch({ type: LOAD_INVITE_MEMBERS_SUCCESS });
      dispatch(listMembersOfSelectedOrg());
    } catch (error) {
      dispatch({ type: LOAD_INVITE_MEMBERS_FAIL, payload: error });
    }
  };

/**
 * Update a member of the selected organization.
 */
export const updateMemberOfSelectedOrg = (memberId, toUpdate) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_UPDATE_MEMBER, payload: memberId });

  const selectedOrganization = getState().get('organization').get('selectedOrganization');

  if (!selectedOrganization || !selectedOrganization.organization?.id) {
    dispatch({ type: LOAD_UPDATE_MEMBER_FAIL, payload: 'No organization selected' });
    return;
  }

  const organizationId = selectedOrganization.organization.id;
  const members = getState().get('organization').get('ownedOrganizationMembers');

  try {
    const response = await api.put(`/organizations/${organizationId}/members/${memberId}`, {
      data: toUpdate
    });

    if (response.message) {
      dispatch({ type: LOAD_UPDATE_MEMBER_FAIL, payload: response.message });
      return;
    }

    const updatedMember = response.rows[0];

    const updatedMemberList = members.map((member) =>
      member.id === memberId ? updatedMember : member
    );

    dispatch({ type: LOAD_UPDATE_MEMBER_SUCCESS });
    dispatch({ type: LOAD_ORGANIZATION_MEMBERS_SUCCESS, payload: updatedMemberList });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_MEMBER_FAIL, payload: error });
  }
};

/**
 * Delete members from the selected organization.
 */
export const deleteMembersFromSelectedOrg = (memberlist) => async (dispatch, getState, api) => {
  const idList = memberlist.map(({ id }) => ({ memberId: id }));

  dispatch({ type: LOAD_DELETE_MEMBERS, payload: idList });

  const selectedOrganization = getState().get('organization').get('selectedOrganization');

  if (!selectedOrganization || !selectedOrganization.organization?.id) {
    dispatch({ type: LOAD_DELETE_MEMBERS_FAIL, payload: 'No organization selected' });
    return;
  }

  const organizationId = selectedOrganization.organization.id;

  try {
    const responses = await Promise.all(
      idList.map(({ memberId }) => api.del(`/organizations/${organizationId}/members/${memberId}`))
    );

    const getMessage = (response) => response && response.message;
    if (responses.some(getMessage)) {
      const messages = responses.map(getMessage).filter((message) => !!message);

      dispatch({ type: LOAD_DELETE_MEMBERS_FAIL, payload: messages });
      return;
    }

    dispatch({ type: LOAD_DELETE_MEMBERS_SUCCESS });
    dispatch(listMembersOfSelectedOrg());
  } catch (error) {
    dispatch({ type: LOAD_DELETE_MEMBERS_FAIL, payload: error });
  }
};

// Selectors
export const getUserId = createSelector(
  (state) => state.get('auth'),
  (auth) => auth.get('user').id
);

export const getOrganizationState = createSelector(
  (state) => state.get('organization'),
  (organization) => organization
);

export const getSelectedOrganization = createSelector(getOrganizationState, (organization) =>
  organization ? organization.get('selectedOrganization') : null
);

export const getIsOrganizationAdmin = createSelector(
  getSelectedOrganization,
  (selectedOrganization) => deep(selectedOrganization, 'role.name') === 'Admin'
);

export const getIsOrganizationViewer = createSelector(
  getSelectedOrganization,
  (selectedOrganization) => deep(selectedOrganization, 'role.name') === 'Viewer'
);

export const getIsOrganizationEditor = createSelector(
  getSelectedOrganization,
  (selectedOrganization) => deep(selectedOrganization, 'role.name') === 'Editor'
);

export const getIsOrganizationViewerOrEditor = createSelector(
  getIsOrganizationViewer,
  getIsOrganizationEditor,
  (isViewer, isEditor) => isViewer || isEditor
);

export const getHasAdminPermissions = createSelector(
  getSelectedOrganization,
  getIsOrganizationAdmin,
  (selectedOrganization, isOrganizationAdmin) => (selectedOrganization ? isOrganizationAdmin : true)
);

export const getOrganizations = createSelector(getOrganizationState, (organization) => {
  const organizationsList = organization.get('memberOrganizations');
  if (!organizationsList || !organizationsList.length) {
    return [];
  }
  return organizationsList.sort(({ role: first }, { role: next }) =>
    first.name.localeCompare(next.name)
  );
});

export const getIsMultiUser = createSelector(
  getOrganizations,
  (organizations) => organizations.length > 0
);

export const getOwnedOrganizationState = createSelector(getOrganizationState, (organization) =>
  organization.get('ownedOrganization')
);

export const getIsContextChanging = createSelector(getOrganizationState, (organization) =>
  organization?.get('contextChange')
);

export const getIsOrganizationOwner = createSelector(
  getOwnedOrganizationState,
  getSelectedOrganization,
  (ownedOrg, selectedOrg) => (selectedOrg ? ownedOrg?.id === selectedOrg?.id : !!ownedOrg)
);

export const getIsOrganizationLoading = createSelector(getOrganizationState, (organization) =>
  organization?.get('loading')
);

export const getHasOrganizationInitiallyLoaded = createSelector(
  getOrganizationState,
  (organization) => organization?.get('hasInitiallyLoaded')
);

export const getSelectedOrganizationId = createSelector(
  getSelectedOrganization,
  (selectedOrg) => selectedOrg?.organization?.id
);

export const getCurrentOrganizationId = createSelector(
  getOwnedOrganizationState,
  getSelectedOrganizationId,
  (ownedOrgState, selectedOrgId) =>
    selectedOrgId && selectedOrgId !== 'null' ? selectedOrgId : ownedOrgState?.id
);

export const getCanManageMembers = createSelector(
  getOrganizationState,
  (organization) => organization?.get('canManageMembers') || false
);

export const getIsOwnerOfSelectedOrg = createSelector(
  getOrganizationState,
  (organization) => organization?.get('isOwnerOfSelectedOrg') || false
);

export const getLoadingCanManageMembers = createSelector(
  getOrganizationState,
  (organization) => organization?.get('loadingCanManageMembers') || false
);



// WEBPACK FOOTER //
// ./src/redux/modules/organization.js